export default {
  mmaclientid: '',
  session: '',
  uin: '',
  rndkey: '',
  prdlocation: -1,
  region: '',
  clientType: 0,
  mobileArea: '',
  mobile: '',
  acctid: '',
  needEncrypt: true,
  needXsign: true
}
